import React, { useState, useEffect } from "react";
import Tab1Image from "../img/envision/energy/cards/energypsistandards.jpg";
import Tab2Image from "../img/envision/energy/cards/energytab2cyber.jpg";
import { useNavigate } from "react-router-dom";

const EnergyPageSecondverticalTabs = () => {
    const [activeTab, setActiveTab] = useState("tab1");
  const [isAutoPlayActive, setIsAutoPlayActive] = useState(true); // State to manage autoplay


    // const handleTabClick = (tab) => setActiveTab(tab);

    const navigate = useNavigate(); // Initialize navigate

    // const handleKnowMoreClick = () => {
    //     // Navigate to the documentaerospacepage with the specific hash
    //     navigate("/documnetEnergyPage#documnetEnergyPageone");
    // };

    const handleKnowMoreClick = (tab) => {
        navigate(`/documnetEnergyPage?tab=${tab}#documnetEnergyPageSEeconddata`);
    };
    const [isHovered, setIsHovered] = useState(false);
    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        setIsAutoPlayActive(false); // Stop auto-play when tab is clicked
      };
    // Autoplay effect to change tabs every 3 seconds (3000ms)
    useEffect(() => {
           let tabInterval;
   
           if (!isHovered && isAutoPlayActive) {
               tabInterval = setInterval(() => {
                   setActiveTab((prevTab) => {
                       const nextTabNum = parseInt(prevTab.replace("tab", "")) % 2 + 1;
                       return `tab${nextTabNum}`;
                   });
               }, 3000);
           }
   
           return () => clearInterval(tabInterval);
       }, [activeTab, isHovered, isAutoPlayActive]);
   
   

    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            display: "flex",
            flexDirection: "row",
            width: "80%",
            margin: "50px auto",
            justifyContent: "space-between",
        },
        tabNav: {

            flexDirection: "column",
            borderRight: "1px solid #fff",
            // height: "350px",
            overflowY: "auto", // Ensure only vertical scrolling
            scrollbarWidth: "thin", // For Firefox
            scrollbarColor: "#ccc transparent", // For Firefox
        },
        // Apply mobile-specific styles for tabNav

        tabButton: {
            padding: "20px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#555",
            outline: "none",
            transition: "color 0.3s, background-color 0.3s",
            borderRadius: "10px",
            margin: "5px 0",
            backgroundColor: "#f0f0f0",
        },
        activeTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        },
        card: {
            display: "flex",
            alignItems: "center",
            padding: "20px",
            borderRadius: "15px",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            width: "100%",
            marginLeft: "10px",
            cursor: "pointer",
        },
        image: {
            width: "382px",
            height: "354px",
            borderRadius: "10px",
            marginRight: "20px",
        },
        textContent: {
            flex: 1,
            textAlign: "left",
            color: "#333",
            height:"388px"
        },
        knowMoreButton: {
            marginTop: "15px",
            padding: "10px 20px",
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            transition: "background-color 0.3s",
            // marginLeft: "150px"
        },
        dotNav: {
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
        },
        dot: {
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: "#ccc",
            margin: "0 5px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        activeDot: {
            backgroundColor: "rgb(236 115 34)",
        },
        // Mobile styling for tabs above content
        mobileContainer: {
            flexDirection: "column", // Stack tabs and content
        },
        mobileTabNav: {
            flexDirection: "row", // Tabs are horizontal on mobile
            justifyContent: "space-around",
            borderRight: "none", // Remove right border for mobile
        },
        mobileCard: {
            flexDirection: "column", // Stack image and text content
            alignItems: "center",
            textAlign: "center",
        },
        mobileImage: {
            width: "100%",
            height: "auto",
            marginRight: "0", // Remove right margin on mobile
        },
        mobileKnowMoreButton: {
            marginLeft: "0", // Center button on mobile
        },
        // Mobile tab navigation change
        mobileTabButton: {
            padding: "20px",
            fontSize: "14px",
            fontWeight: "normal",
            color: "#555",
            backgroundColor: "#f0f0f0",
            border: "none",
            cursor: "pointer",
            outline: "none",
            textAlign: "center",
        },
        activeMobileTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        }
    };

    return (
        <div style={{ marginTop: '100px' }}>
            <h1 style={{ textAlign: "center" }}>
            <span style={{ color: "rgb(236 115 34)" }}> Integrated (ISO-PCI) </span>  Compliance services
            </h1>

            <div style={{ ...styles.container, ...(window.innerWidth <= 768 ? styles.mobileContainer : {}) }} className="tabclass-container-data">
                {/* Tab Navigation */}
                <div style={{ ...styles.tabNav, ...(window.innerWidth <= 768 ? styles.mobileTabNav : {}) }} className="tabdata">
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab1" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab1")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab1") {
                                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (activeTab !== "tab1") {
                                e.currentTarget.style.backgroundColor = ""; // Revert background
                                e.currentTarget.style.color = ""; // Revert text color
                            }
                        }}

                    >
                        PCI Standards
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab2" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab2")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab2") {
                                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (activeTab !== "tab2") {
                                e.currentTarget.style.backgroundColor = ""; // Revert background
                                e.currentTarget.style.color = ""; // Revert text color
                            }
                        }}

                    >
                        Cybersecurity & IT/OT Security Standards
                    </button>

                </div>

                {/* Tab Content */}
                <div style={{ ...styles.card, ...(window.innerWidth <= 768 ? styles.mobileCard : {}) }} onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}>
                    <img
                        src={{ tab1: Tab1Image, tab2: Tab2Image, }[activeTab]}
                        alt="Aerospace"
                        style={{ ...styles.image, ...(window.innerWidth <= 768 ? styles.mobileImage : {}) }}
                    />
                    <div style={styles.textContent}>
                        {(() => {
                            const tabIndex = parseInt(activeTab.replace("tab", "")) - 1;
                            const contentArray = [
                                [
                                    "PCI DSS v4.0 – Secure payment transactions for utility bills, toll payments, and infrastructure services.",
                                    "PCI PTS (PIN Transaction Security) – Securing POS and kiosk-based payment systems.",
                                    "PCI PA-DSS (Payment Application Security) – Compliance for billing software & smart grid payment apps.",
                                    "PCI SSF (Software Security Framework) – Ensuring security in digital payment solutions used in energy and infrastructure.",
                                ],
                                [
                                    "ISO/IEC 27001 – Information Security Management System (ISMS) compliance",
                                    "ISO/IEC 27019 – Cybersecurity for Energy & Utility Control Systems (SCADA, ICS, and IIoT systems) compliance",
                                    "ISO/IEC 62443 – Industrial Automation & Control System (IACS) Cybersecurity compliance",
                                    "ISO/SAE 21434 – Cybersecurity for Automotive & Smart Mobility",
                                    "ISO 55001 – Asset Management for Infrastructure & Utilities"
                                ],

                            ];

                            // Ensure the selected content is within range and not undefined
                            const selectedContent = contentArray[tabIndex] || [];

                            return selectedContent.map((point, index) => (
                                <ul key={index}>
                                    <li>{point}</li>
                                </ul>
                            ));
                        })()}

                        {/* <button
                            style={{ ...styles.knowMoreButton, ...(window.innerWidth <= 768 ? styles.mobileKnowMoreButton : {}) }}
                            onClick={handleKnowMoreClick}
                            className="know-more-btn"
                        >
                            Know More
                        </button> */}
                          {["tab1", "tab2"].includes(activeTab) && (
                            <button   style={{ ...styles.knowMoreButton, ...(window.innerWidth <= 768 ? styles.mobileKnowMoreButton : {}) }}
                             onClick={() => handleKnowMoreClick(activeTab)} className="know-more-btn">
                                Know More
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {/* Dot Navigation for 3 Tabs */}
            <div style={styles.dotNav}>
                {[...Array(2)].map((_, index) => {
                    const tab = `tab${index + 1}`;
                    return (
                        <div
                            key={tab}
                            style={{
                                ...styles.dot,
                                ...(activeTab === tab ? styles.activeDot : {}),
                            }}
                            onClick={() => handleTabClick(tab)}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default EnergyPageSecondverticalTabs;
